const imp = () => import(/* webpackChunkName: "loadSprite_mgt_dh"*/  "../sprite/loadSprite_mgt_dh");

const loadMap_mgt_dh: { [key: string]: () => Promise<any> } = {
  /* 通用 */
  "Icon-N-Other-permissions": imp,
  "Icon-N-System-settings": imp,
  "Icon-N-Administrativeregionsetting": imp,
  "Icon-N-Commentsettings": imp,
  "Icon-N-Mapsettings": imp,
  "Icon-N-Publicphrase": imp,
  "Icon-N-Pluginsettings": imp,
  "Icon-N-Requiredsettings": imp,
  /** 集成中心 */
  "Icon-N-AgreementManagement": imp,
  "Icon-N-Conversionrulebase": imp,
  "Icon-N-Databaseinterface": imp,
  "Icon-N-Functionsettings": imp,
  "Icon-N-Integratedlogin": imp,
  "Icon-N-Integrationlog": imp,
  "Icon-N-Mailboxsettings": imp,
  "Icon-N-Synchronizationlog": imp,
  "Icon-N-Synchronizationsettings": imp,
  "Icon-N-Pushlog": imp,
  "Icon-N-applicationsystem": imp,
  "Icon-N-encryptionalgorithm": imp,
  /** 区域语言 */
  "Icon-N-Labelmaintenance": imp,
  "Icon-N-Translationmode": imp,
  "Icon-N-Datetime": imp,
  "Icon-N-Languagemanagement": imp,
  "Icon-N-MT": imp,
  "Icon-N-MT-o": imp,
  /** 基础服务 */
  "Icon-N-Blackandwhitelist": imp,
  "Icon-N-Invitationlist": imp,
  "Icon-N-Loginmode": imp,
  "Icon-N-Loginpagesettings": imp,
  "Icon-N-Numbersetting": imp,
  "Icon-N-Quicknewsettings": imp,
  "Icon-N-Teamauthorization": imp,
  "Icon-N-devicemanagement": imp,
  "Icon-N-securitysetting": imp,
  /** 短信 */
  "Icon-N-Signatureaudit": imp,
  "Icon-N-Templatereview": imp,
  /** 项目 */
  "Icon-N-Contextmenu": imp,
  "Icon-N-Linkagesetting": imp,
  "Icon-N-Rulesettings": imp,
  /** 任务 */
  "Icon-N-Operationsettings": imp,
  "Icon-N-Rolesettings": imp,
  "Icon-N-Triggerrul": imp,
  "Icon-N-Typesettings": imp,
  /** 邮件 */
  "Icon-N-Mailboxerror": imp,
  "Icon-N-Receivingrules": imp,
  "Icon-N-Receivecachesettings": imp,
  "Icon-N-Templatesettings": imp,
  "Icon-N-portsettings": imp,
  /** CRM */
  "Icon-N-Approvalsettings": imp,
  "Icon-N-Cardsettings": imp,
  "Icon-N-Basicsettings": imp,
  "Icon-N-Customervalue": imp,
  "Icon-N-ModuleAssociation": imp,
  "Icon-N-Optionsettings": imp,
  "Icon-N-Mappingrules": imp,
  "Icon-N-Ordercopy": imp,
  "Icon-N-Orderprocess": imp,
  "Icon-N-Permissionsetting": imp,
  "Icon-N-Riskembedmentpoint": imp,
  /** 协作 */
  "Icon-N-Categorysettings": imp,
  "Icon-N-Platesetup": imp,
  /** 公文 */
  "Icon-N-Officialdocumentspecification": imp,
  "Icon-N-Teammenu": imp,
  /** 表单引擎 */
  "Icon-N-Advanced-form-style-template": imp,
  "Icon-N-Option-template": imp,
  "Icon-N-Field-template-library": imp,
  /** 工作消息 */
  "Icon-N-Chat-toolbar": imp,
  "Icon-N-Custom-emoticon": imp,
  "Icon-N-Department-group-chat": imp,
  "Icon-N-Function-settings": imp,
  "Icon-N-Message-action-menu": imp,
  "Icon-N-Message-type": imp,
  "Icon-N-Search-settings": imp,
  "Icon-N-Push-settings": imp,
  "Icon-N-Watermark-settings": imp,
  "Icon-N-Top-session-settings": imp,
  /** 终端设置 */
  "Icon-N-Client-log": imp,
  "Icon-N-Code-scanning-setting": imp,
  "Icon-N-Endorsement-settings": imp,
  "Icon-N-Face-settings": imp,
  "Icon-N-Navigation-settings": imp,
  "Icon-N-Version-settings": imp,
  /** 流程 */
  "Icon-N-Customquery-": imp,
  "Icon-N-Batchmaintenance": imp,
  "Icon-N-Approvalprocessmanagement": imp,
  "Icon-N-Applysettings": imp,
  "Icon-N-Numbermaintenance": imp,
  "Icon-N-Reportsettings": imp,
  "Icon-N-Monitoringmanagement": imp,
  "Icon-N-Datamaintenance": imp,
  /** 协同区 */
  "Icon-N-Connector": imp,
  "Icon-N-Integration-Suite": imp,
  "Icon-N-Approval-collaboration": imp,
  "Icon-N-Approval-collaboration-o": imp,
  /** 数据源 */
  "Icon-N-Data-connection": imp,
  "Icon-N-Data-set": imp,
  /** 会议设置 */
  "Icon-N-Meeting-process-settings": imp,
  "Icon-N-Meeting-field-settings": imp,
  "Icon-N-SIM-card-template-settings": imp,
  "Icon-N-Video-conferencing-settings": imp,
  "Icon-N-Meeting-sharing-settings": imp,
  /** 权限管理中心 */
  "Icon-N-Administrator-maintenance": imp,
  "Icon-N-Decentralized-management-center": imp,
  "Icon-N-Permission-settings-for-related-matters": imp,
  /** 全文检索 */
  "Icon-N-Intelligent-instruction": imp,
  "Icon-N-Search-page-customization": imp,
  /** 数据安全 */
  "Icon-N-Data-encryption": imp,
  "Icon-N-Hierarchical-protection-settings": imp,
  "Icon-N-Sensitive-words": imp,
  /** 绩效考核 */
  "Icon-N-Fractional-segment-setting": imp,
  "Icon-N-Reminder-settings": imp,
  "Icon-N-Scheme-settings": imp,
  /** 审计日志 */
  "Icon-N-Audit-log-import": imp,
  "Icon-N-General-personnel-log": imp,
  "Icon-N-Audit-log-archiving": imp,
  "Icon-N-Security-officer-log": imp,
  "Icon-N-Audit-log-view": imp,
  "Icon-N-Security-Auditor-log": imp,
  "Icon-N-System-administrator-log": imp,
  /** 电子签后台tab图标 */
  "Icon-N-Company-information": imp,
  "Icon-N-Company-seal": imp,
  "Icon-N-Individual-seal": imp,
  "Icon-N-Physical-seal": imp,
  "Icon-N-Seal-management": imp,
  "Icon-N-Binding-settings": imp,
  "Icon-N-Expense-Center": imp,

  "Icon-Common-words": imp,
  "Icon-Collection-o": imp,
  "Icon-Department-move-in-o": imp,
  "Icon-Message-file": imp,
  "Icon-Enterprise-wechat02-o": imp,
  "Icon-Mutual-concern-o": imp,
  "Icon-N-AgreementManagement-o": imp,
  "Icon-N-Administrativeregionsetting-o": imp,
  "Icon-N-Applysettings-o": imp,
  "Icon-N-Approvalsettings-o": imp,
  "Icon-N-Approvalprocessmanagement-o": imp,
  "Icon-N-Cardsettings-o": imp,
  "Icon-N-Basicsettings-o": imp,
  "Icon-N-Batchmaintenance-o": imp,
  "Icon-N-Blackandwhitelist-o": imp,
  "Icon-N-Conversionrulebase-o": imp,
  "Icon-N-Commentsettings-o": imp,
  "Icon-N-Contextmenu-o": imp,
  "Icon-N-Customquery-o": imp,
  "Icon-N-Customervalue-o": imp,
  "Icon-N-Databaseinterface-o": imp,
  "Icon-N-Datetime-o": imp,
  "Icon-N-Datamaintenance-o": imp,
  "Icon-N-Functionsettings-o": imp,
  "Icon-N-Defaultavatarsettings-o": imp,
  "Icon-N-Integrationlog-o": imp,
  "Icon-N-Integratedlogin-o": imp,
  "Icon-N-Defaultavatarsettings": imp,
  "Icon-N-Languagemanagement-o": imp,
  "Icon-N-Invitationlist-o": imp,
  "Icon-N-Linkagesetting-o": imp,
  "Icon-N-Loginmode-o": imp,
  "Icon-N-Loginpagesettings-o": imp,
  "Icon-N-Mailboxsettings-o": imp,
  "Icon-N-Mappingrules-o": imp,
  "Icon-N-Mapsettings-o": imp,
  "Icon-N-ModuleAssociation-o": imp,
  "Icon-N-Monitoringmanagement-o": imp,
  "Icon-N-Numbermaintenance-o": imp,
  "Icon-N-Officialdocumentspecification-o": imp,
  "Icon-N-Operationsettings-o": imp,
  "Icon-N-Optionsettings-o": imp,
  "Icon-N-Orderprocess-o": imp,
  "Icon-N-Permissionsetting-o": imp,
  "Icon-N-Ordercopy-o": imp,
  "Icon-N-Platesetup-o": imp,
  "Icon-N-Labelmaintenance-o": imp,
  "Icon-N-Publicphrase-o": imp,
  "Icon-N-Pushlog-o": imp,
  "Icon-N-Pluginsettings-o": imp,
  "Icon-N-Quicknewsettings-o": imp,
  "Icon-N-Requiredsettings-o": imp,
  "Icon-N-Reportsettings-o": imp,
  "Icon-N-Riskembedmentpoint-o": imp,
  "Icon-N-Rulesettings-o": imp,
  "Icon-N-Rolesettings-o": imp,
  "Icon-N-Synchronizationlog-o": imp,
  "Icon-N-Teamauthorization-o": imp,
  "Icon-N-Teammenu-o": imp,
  "Icon-N-Synchronizationsettings-o": imp,
  "Icon-N-Categorysettings-o": imp,
  "Icon-N-Translationmode-o": imp,
  "Icon-N-Typesettings-o": imp,
  "Icon-N-Triggerrul-o": imp,
  "Icon-N-applicationsystem-o": imp,
  "Icon-N-devicemanagement-o": imp,
  "Icon-Node-recovery-station-o": imp,
  "Icon-N-encryptionalgorithm-o": imp,
  "Icon-Print-log-o": imp,
  "Icon-N-securitysetting-o": imp,
  "Icon-Printing-o": imp,
  "Icon-Receivingandsendingunit-o": imp,
  "Icon-Subtask-o": imp,
  "Icon-Task-work-o": imp,
  "Icon-delete04-o": imp,
  "Icon-send-out-o": imp,
  "Icon-Total-person-time-o": imp,
  "Icon-risk-o": imp,
  "Icon-Numbered-list-o": imp,
  "Icon-N-Administrator-maintenance-o": imp,
  "Icon-N-Field-template-library-o": imp,
  "Icon-N-Advanced-form-style-template-o": imp,
  "Icon-N-Approval-type-o": imp,
  "Icon-N-Audit-log-archiving-o": imp,
  "Icon-N-Audit-log-import-o": imp,
  "Icon-N-Audit-log-view-o": imp,
  "Icon-N-Binding-settings-o": imp,
  "Icon-N-Chat-toolbar-o": imp,
  "Icon-N-Client-log-o": imp,
  "Icon-N-Collection-maintenance-o": imp,
  "Icon-N-Company-information-o": imp,
  "Icon-N-Company-seal-o": imp,
  "Icon-N-Connector-o": imp,
  "Icon-N-Cost-standard-o": imp,
  "Icon-N-Custom-emoticon-o": imp,
  "Icon-N-Data-connection-o": imp,
  "Icon-N-Data-encryption-o": imp,
  "Icon-N-Data-set-o": imp,
  "Icon-N-Decentralized-management-center-o": imp,
  "Icon-N-Department-group-chat-o": imp,
  "Icon-N-Endorsement-settings-o": imp,
  "Icon-N-Expense-Center-o": imp,
  "Icon-N-Face-settings-o": imp,
  "Icon-N-Code-scanning-setting-o": imp,
  "Icon-N-Form-settings-o": imp,
  "Icon-N-Fractional-segment-setting-o": imp,
  "Icon-N-Function-settings-o": imp,
  "Icon-N-General-personnel-log-o": imp,
  "Icon-N-Hierarchical-protection-settings-o": imp,
  "Icon-N-Individual-seal-o": imp,
  "Icon-N-Integration-Suite-o": imp,
  "Icon-N-Intelligent-instruction-o": imp,
  "Icon-N-Meeting-field-settings-o": imp,
  "Icon-N-Meeting-process-settings-o": imp,
  "Icon-N-Meeting-sharing-settings-o": imp,
  "Icon-N-Message-action-menu-o": imp,
  "Icon-N-Message-type-o": imp,
  "Icon-N-Navigation-settings-o": imp,
  "Icon-N-Option-template-o": imp,
  "Icon-N-Physical-seal-o": imp,
  "Icon-N-Permission-settings-for-related-matters-o": imp,
  "Icon-N-Push-settings-o": imp,
  "Icon-N-Reminder-settings-o": imp,
  "Icon-N-Reimbursement-maintenance-o": imp,
  "Icon-N-SIM-card-template-settings-o": imp,
  "Icon-N-Scheme-settings-o": imp,
  "Icon-N-Search-page-customization-o": imp,
  "Icon-N-Seal-management-o": imp,
  "Icon-N-Security-Auditor-log-o": imp,
  "Icon-N-Search-settings-o": imp,
  "Icon-N-Security-officer-log-o": imp,
  "Icon-N-Sensitive-words-o": imp,
  "Icon-N-System-administrator-log-o": imp,
  "Icon-N-Top-session-settings-o": imp,
  "Icon-N-Version-settings-o": imp,
  "Icon-N-Video-conferencing-settings-o": imp,
  "Icon-N-Watermark-settings-o": imp,
  "Icon-N-Document-template-settings-o": imp,
  "Icon-N-Document-template-settings": imp,
  "Icon-N-Folder-settings": imp,
  "Icon-N-Folder-settings-o": imp,
  "Icon-N-Folder-template-settings": imp,
  "Icon-N-Folder-template-settings-o": imp,
  "Icon-N-Homepage-Popup": imp,
  "Icon-N-Homepage-Popup-o": imp,
  "Icon-N-Financial-closing-o": imp,
  "Icon-N-Financial-closing": imp,
  "Icon-N-Approval-type": imp,
  "Icon-N-Collection-maintenance": imp,
  "Icon-N-Form-settings": imp,
  "Icon-N-Reimbursement-maintenance": imp,
  "Icon-N-Cost-standard": imp,
  "Icon-N-Allocation-settings-o": imp,
  "Icon-N-Budget-settings-o": imp,
  "Icon-N-Fee-settings-o": imp,
  "Icon-N-Allocation-settings": imp,
  "Icon-N-Fee-settings": imp,
  "Icon-N-Budget-settings": imp,
  "Icon-Expense-type-o": imp,
  "Icon-Expense-type": imp,
  "Icon-N-Blacklist-settings-o": imp,
  "Icon-N-Blacklist-settings": imp,
  "Icon-N-Intelligent-ticket-review-settings": imp,
  "Icon-N-Intelligent-ticket-review-settings-o": imp,
  "Icon-N-Interface-Expiration-Notification-o": imp,
  "Icon-N-Invoice-process-settings-o": imp,
  "Icon-N-Invoice-process-settings": imp,
  "Icon-N-Interface-Expiration-Notification": imp,
  "Icon-N-White-list-settings": imp,
  "Icon-N-White-list-settings-o": imp,

}
export default loadMap_mgt_dh;

